import React from 'react';

import { EUserStoreRole } from '@domain/enums/common/userStore/EUserStoreRole';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import { BoletoProvider } from '@helpers/hooks/pages/dashboard/boleto/useBoleto';

import Wrapper from '@components/Dashboard/Boleto/Wrapper';
import NoAccess from '@components/common/core/Utils/NoAccess';

const Boleto: React.FC = () => {
  const { accessManagementData } = useStoreConfig();
  const { isInternalTeam } = useConfig();

  const isStoreOwner = accessManagementData?.role === EUserStoreRole.OWNER;
  const hasAccessToPage =
    accessManagementData?.group?.has_boleto_table_full_write_access ||
    accessManagementData?.group?.has_boleto_table_full_read_access;

  if (!isStoreOwner && !hasAccessToPage && !isInternalTeam) {
    return <NoAccess />;
  }

  return (
    <BoletoProvider>
      <Wrapper />
    </BoletoProvider>
  );
};

export default Boleto;
